// General Configuration
export const IS_DATA_ENCRYPTED = true;
export const IS_OPENREPLAY_ENABLED = false;

export const IS_CPR_ENABLED = true;
export const IS_FAF_ENABLED = true;
export const IS_CASE_ENABLED = true;

export const PARTNER_BROWSER_ID = {
  ID: '',
  expired: false,
}


// export const PARTNER_AUTH = { Authorization: '--' };
// export const CPR_AUTH = { Authorization: '--' };
// export const FAF_AUTH = { Authorization: '--' };
export const CASE_AUTH = { Authorization: '--' };

export const PARTNER_AUTH =  { Authorization: '--' };
export const preLoginToken_PPP = { token: '--' };
export const postLoginToken_PPP = { token: '--' };
export const authToken_PPP = { token: '--' };
export const jwtToken_PPP = { token: '--' };
export const jwt_PPP= { token: '--' };

export const FAF_AUTH = { Authorization: '--' };
export const preLoginToken_FAF = { token: '--' };
export const postLoginToken_FAF = { token: '--' };
export const authToken_FAF = { token: '--' };
export const jwtToken_FAF = { token: '--' };
export const jwt_FAF= { token: '--' };

export const CPR_AUTH = { Authorization: '--' };
export const preLoginToken_CPR = { token: '--' };
export const postLoginToken_CPR = { token: '--' };
export const authToken_CPR = { token: '--' };
export const jwtToken_CPR = { token: '--' };
export const jwt_CPR= { token: '--' };

export const PARTNER_AK_VALUE = {value:""};
export const CPR_AK_VALUE = {value:""};
export const FAF_AK_VALUE = {value:""};
export const CASE_AK_VALUE = {value:""};

export const isLoader = { value: false };

export const systemData = {
  userAgent: '',
  ipAddress: ''
}

export const payableToDropdown = [
  { key: "Patient/Guardian", value: "Patient/Guardian" },
  { key: "Provider", value: "Provider" },
  { key: "Other", value: "Other" }
]
export const payableToDropdownWithInsurance = [
  { key: "Patient/Guardian", value: "Patient/Guardian" },
  { key: "Provider", value: "Provider" },
  { key: "Insurance", value: "Insurance" },
  { key: "Other", value: "Other" }
]


//supertoken dev
// export const SUPERTOKEN_BASE_URL = "http://localhost:9000";
// export const SUPERTOKEN_WEBSITE_URL = "http://localhost:3000";
// export const SUPERTOKEN_API_BASE_PATH = "/"

// Production
// NON-Expiry Browser-Id
export const CPR_BROWSERID = process.env.REACT_APP_CPR_BROWSERID
export const FAF_BROWSERID = process.env.REACT_APP_FAF_BROWSERID

// AZURE END POINT
export const BASE_AZURE_URL = process.env.REACT_APP_BASE_AZURE_URL
export const CPR_BASE_AZURE_URL = process.env.REACT_APP_CPR_BASE_AZURE_URL
export const FAF_BASE_AZURE_URL = process.env.REACT_APP_FAF_BASE_AZURE_URL
export const CASE_BASE_AZURE_URL = process.env.REACT_APP_CASE_BASE_AZURE_URL
// export const CASE_BASE_AZURE_URL = "https://pafcm--cmdev.sandbox.my.site.com/nppp/services/apexrest/"
export const VIEW_CASE_REDIRECTION_URL = process.env.REACT_APP_VIEW_CASE_REDIRECTION_URL
export const SF_LOGOUT_IFRAME = process.env.REACT_APP_SF_LOGOUT_IFRAME

// CASE
export const CASE_OAUTH_TOKEN_URL = process.env.REACT_APP_CASE_OAUTH_TOKEN_URL
export const CASE_CP_REDIRECTION_URL = process.env.REACT_APP_CASE_CP_REDIRECTION_URL
export const SF_CASE_BASE_AZURE_URL = process.env.REACT_APP_SF_CASE_BASE_AZURE_URL

// PEGA END POINT
export const BASE_URL= process.env.REACT_APP_BASE_URL
export const CPR_BASE_URL= process.env.REACT_APP_CPR_BASE_URL
export const FAF_BASE_URL= process.env.REACT_APP_FAF_BASE_URL
export const SALESFORCE_BASE_URL = process.env.REACT_APP_SALESFORCE_BASE_URL
export const EDUCATION_RESOURCE_DIRECTORY = process.env.REACT_APP_EDUCATION_RESOURCE_DIRECTORY

export const SMARTYSTREET_KEY = process.env.REACT_APP_SMARTYSTREET_KEY
export const SKIP_SMARTY_STREET_VERIFICATION= process.env.REACT_APP_SKIP_SMARTY_STREET_VERIFICATION
export const CASE_MANAGEMENT_URL = process.env.REACT_APP_CASE_MANAGEMENT_URL
export const API_TRACE = process.env.REACT_APP_API_TRACE
export const SUBSCRIPTION_KEY = process.env.REACT_APP_SUBSCRIPTION_KEY

// Doc-Studio Correspondence URL
// export const DOCSTUDIO_REPLACE_URL = "https://api.copays.org/oldpds/DocStudio/live/print/correspondence/";
// export const DOCSTUDIO_REPLACE_LIVE_URL = "https://api.copays.org/oldpds/DocStudio/live/print/correspondence/";
// export const DOCSTUDIO_HTML_REPLACE_URL = "https://api.copays.org/oldpds/DocStudio/getEmailResource/html/";
// export const DOCSTUDIO_ATTACHMENT_REPLACE_URL = "https://api.copays.org/oldpds/DocStudio/getEmailResource/attachment/";

export const DOCSTUDIO_REPLACE_URL = process.env.REACT_APP_DOCSTUDIO_REPLACE_URL
export const OLD_DOCSTUDIO_REPLACE_URL = process.env.REACT_APP_OLD_DOCSTUDIO_REPLACE_URL
export const UAT_DOCSTUDIO_REPLACE_URL = process.env.REACT_APP_UAT_DOCSTUDIO_REPLACE_URL

// //SuperTokens Config
export const SUPERTOKEN_BASE_URL = process.env.REACT_APP_SUPERTOKEN_BASE_URL
export const SUPERTOKEN_WEBSITE_URL = process.env.REACT_APP_SUPERTOKEN_WEBSITE_URL
export const SUPERTOKEN_API_BASE_PATH = process.env.REACT_APP_SUPERTOKEN_API_BASE_PATH

//SuperTokens Config PPP
export const SUPERTOKEN_OAUTHURL_PPP = process.env.REACT_APP_SUPERTOKEN_OAUTHURL_PPP
export const REGISTRATION_CLIENT_SECRET_PPP = process.env.REACT_APP_REGISTRATION_CLIENT_SECRET_PPP
export const CLIENT_ID_PPP = process.env.REACT_APP_CLIENT_ID_PPP
export const OAUTH_CLIENT_SECRET_PPP = process.env.REACT_APP_OAUTH_CLIENT_SECRET_PPP
export const ENVIRONMENT_ID_PPP = process.env.REACT_APP_ENVIRONMENT_ID_PPP

//SuperTokens Config FAF
export const SUPERTOKEN_OAUTHURL_FAF = process.env.REACT_APP_SUPERTOKEN_OAUTHURL_FAF
export const REGISTRATION_CLIENT_SECRET_FAF = process.env.REACT_APP_REGISTRATION_CLIENT_SECRET_FAF
export const CLIENT_ID_FAF = process.env.REACT_APP_CLIENT_ID_FAF
export const OAUTH_CLIENT_SECRET_FAF = process.env.REACT_APP_OAUTH_CLIENT_SECRET_FAF
export const ENVIRONMENT_ID_FAF = process.env.REACT_APP_ENVIRONMENT_ID_FAF

//SuperTokens Config CPR
export const SUPERTOKEN_OAUTHURL_CPR = process.env.REACT_APP_SUPERTOKEN_OAUTHURL_CPR
export const REGISTRATION_CLIENT_SECRET_CPR = process.env.REACT_APP_REGISTRATION_CLIENT_SECRET_CPR
export const CLIENT_ID_CPR = process.env.REACT_APP_CLIENT_ID_CPR
export const OAUTH_CLIENT_SECRET_CPR = process.env.REACT_APP_OAUTH_CLIENT_SECRET_CPR
export const ENVIRONMENT_ID_CPR = process.env.REACT_APP_ENVIRONMENT_ID_CPR

export const PUBLIC_API_KEY = process.env.REACT_APP_PUBLIC_API_KEY
export const SECRET_API_KEY = process.env.REACT_APP_SECRET_API_KEY
export const ENVIRONMENT_ID = process.env.REACT_APP_ENVIRONMENT_ID

//Cookie Bot
export const IS_COOKIE_BOT_ENABLED = process.env.REACT_APP_IS_COOKIE_BOT_ENABLED === "true"


export const DROPDOWN_STATES =
  [
    { key: "AL", value: "Alabama" },
    { key: "AK", value: "Alaska" },
    { key: "AS", value: "American Samoa" },
    { key: "AZ", value: "Arizona" },
    { key: "AR", value: "Arkansas" },
    { key: "CA", value: "California" },
    { key: "CO", value: "Colorado" },
    { key: "CT", value: "Connecticut" },
    { key: "DE", value: "Delaware" },
    { key: "DC", value: "District of Columbia" },
    { key: "FM", value: "Federated States of Micronesia" },
    { key: "FL", value: "Florida" },
    { key: "GA", value: "Georgia" },
    { key: "GU", value: "Guam" },
    { key: "HI", value: "Hawaii" },
    { key: "ID", value: "Idaho" },
    { key: "IL", value: "Illinois" },
    { key: "IN", value: "Indiana" },
    { key: "IA", value: "Iowa" },
    { key: "KS", value: "Kansas" },
    { key: "KY", value: "Kentucky" },
    { key: "LA", value: "Louisiana" },
    { key: "ME", value: "Maine" },
    { key: "MH", value: "Marshall Islands" },
    { key: "MD", value: "Maryland" },
    { key: "MA", value: "Massachusetts" },
    { key: "MI", value: "Michigan" },
    { key: "MN", value: "Minnesota" },
    { key: "MS", value: "Mississippi" },
    { key: "MO", value: "Missouri" },
    { key: "MT", value: "Montana" },
    { key: "NE", value: "Nebraska" },
    { key: "NV", value: "Nevada" },
    { key: "NH", value: "New Hampshire" },
    { key: "NJ", value: "New Jersey" },
    { key: "NM", value: "New Mexico" },
    { key: "NY", value: "New York" },
    { key: "NC", value: "North Carolina" },
    { key: "ND", value: "North Dakota" },
    { key: "MP", value: "Northern Mariana Islands" },
    { key: "OH", value: "Ohio" },
    { key: "OK", value: "Oklahoma" },
    { key: "OR", value: "Oregon" },
    { key: "PW", value: "Palau" },
    { key: "PA", value: "Pennsylvania" },
    { key: "PR", value: "Puerto Rico" },
    { key: "RI", value: "Rhode Island" },
    { key: "SC", value: "South Carolina" },
    { key: "SD", value: "South Dakota" },
    { key: "TN", value: "Tennessee" },
    { key: "TX", value: "Texas" },
    { key: "UT", value: "Utah" },
    { key: "VT", value: "Vermont" },
    { key: "VI", value: "Virgin Islands" },
    { key: "VA", value: "Virginia" },
    { key: "WA", value: "Washington" },
    { key: "WV", value: "West Virginia" },
    { key: "WI", value: "Wisconsin" },
    { key: "WY", value: "Wyoming" },
  ];

